export default class ServiceProviderService {
    createServiceProvider = (data) => {
        return axios.post(`/providers`, data);
    };

    updateServiceProvider = (provider, data) => {
        return axios.put(`/providers/${provider}`, data);
    };
}
